/* eslint-disable import/prefer-default-export */
import { put } from 'redux-saga/effects';
import { head } from 'ramda';
import { setRuntime } from '../actions/runtime';
import { isMobile } from '@/utils/detect';


const locale = 'de-De';

export function* runtimeSaga() {
  yield put(
    setRuntime({
      browser: 'ie:11',
      platform: isMobile ? 'mobile' : 'desktop',
      language: head(locale.split('-')),
      locale,
    }),
  );
}
